/**
 * Created by guoliangfang on 2017/8/23.
 */
import _ from 'lodash';
import React from 'react';

import {connect} from 'react-redux';
import abortAjaxHoc from 'components/abortAjaxHoc';

import {Button, Modal} from 'antd';
import {Form, Input, Radio, Spin} from 'antd';

import UserRoleTable from '../UserRoleTable';
import UserPermissionTree from '../UserPermissionTree';
import {toUrl} from 'utils/tool.js';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const OPTIONS = {
    'name': {
        rules: [
            {required: true, message: 'Please enter sub-account name'},
            {pattern: /^[a-zA-Z][0-9a-zA-Z-]{5,19}$/, message: 'Invalid sub-account name format'}
        ]
    },
    'id_card': {
        rules: [
            {pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: 'Invalid ID card format'}
        ]
    },
    'real_name': {
        rules: [
            {type: 'string', message: 'Invalid name format, length should be between 2-32 characters', min: 2, max: 32}
        ]
    },
    'display_name': {
        rules: [
            {required: true, message: 'Please enter username'},
            {type: 'string', message: 'Invalid username format, length should be between 2-32 characters', min: 2, max: 32}
        ]
    },
    'phone': {
        // 全球手机号规则
        rules: [
            {pattern: /^\+?[0-9-()]*[0-9]+$/, message: 'Please enter a valid phone number'}
        ]
    },
    'email': {
        rules: [
            {type: 'email', message: 'Invalid email format'},
            {required: true, message: 'Please enter a valid email address'}
        ]
    },
    'description': {
        rules: [
            {type: 'string', message: 'Description cannot exceed 640 characters!', min: 0, max: 640}
        ]
    },
    'if_use_watermark':{
        valuePropName: 'checked'
    }
};

class SubAccountForm extends React.Component {
    static getLabel(text, span) {
        return (
            <span>
                {text}
                {span && <span style={{color:'#aaa',fontSize:'12px',marginLeft:10}}>{span}</span>}
            </span>
        );
    }

    constructor(props) {
        super(props);
        const {id} = props;
        this.accountId = id;
        this.state = {
            loading: true,
            radioSelect: 'role',
            role_ids: [],
            roles_permission_list: [],
            permission_list:[]
        };
    }

    componentDidMount(){
        //account_roles 当前客户的角色列表

        const allRolesPromise = this.props.abortableAjax('GET', '/auth/user/current/role');
        let accountRolesPromise = Promise.resolve();
        let accountPermPromis = Promise.resolve();
        let accountInfoPrmoise = Promise.resolve();
        if(this.accountId){
            accountInfoPrmoise = this.props.abortableAjax('GET', `/sub_accounts/${this.accountId}`).then((res)=>{
                const data = res.data;
                data.name = data.name.split(':')[1];
                this.props.form.setFieldsValue(data || {});
            });
            accountRolesPromise = this.props.abortableAjax('GET', `/auth/sub-account/${this.accountId}/roles`).then((res)=>{
                const roles = res.data || [];
                return roles.map((item)=>{
                    return item.id;
                });
            });
            accountPermPromis = this.props.abortableAjax('GET', `/auth/sub-account/${this.accountId}/permissions`).then((res)=>{
                const account_perm = res.data.map((item)=>{
                    return item.id.toString();
                });
                return account_perm || [];
            });
        }
        const allPermissionsPromise = this.props.abortableAjax('GET', '/auth/permissions').then((res)=>{
            return res.data || [];
        });
        Promise.all([allRolesPromise, accountRolesPromise, allPermissionsPromise, accountPermPromis, accountInfoPrmoise]).then((res)=>{
            const [userRoleData, account_roles, permissions, account_perm] = res;
            const userRole = userRoleData.data || [];
            let default_perm_list, other_perm;
            default_perm_list = [];
            other_perm = [];

            //获取所有非子节点
            const parentsPerms = this.getAllParentPermission(permissions);
            //获取当前已有的所有权限排除父节点
            //去掉莫名其妙的权限点
            let cleanPerm, account_perms;
            if(permissions){
                const all_perms = permissions.map(item=>item.id.toString());
                console.log(parentsPerms,account_perm,all_perms);
                if(account_perm) {
                    account_perms = account_perm.filter((item)=>{
                        return all_perms.indexOf(item)>-1;
                    });
                }
                cleanPerm = _.difference(account_perms, parentsPerms);
            }
            //重组每个角色包含的权限点
            const perms_by_role_id = this.formatPermsByRoleId(userRole);
            for (const key in perms_by_role_id) {
                if (account_roles && account_roles.indexOf(Math.ceil(key)) > -1) {
                    default_perm_list = _.union(default_perm_list, perms_by_role_id[key]);
                }
            }
            default_perm_list = this.setArrayNumToString(default_perm_list);
            //角色以外的权限点
            other_perm = _.difference(cleanPerm, default_perm_list);

            this.setState({
                loading: false,
                radioSelect: 'role',
                perms_by_role_id,
                role_ids: account_roles || [],
                roles_permission_list: default_perm_list ? default_perm_list : [],
                permission_list: other_perm || [],
                permissions,
                userRole
            });
        });

    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    loading: true
                });
                const {role_ids, permission_list} = this.state;
                values.roles = role_ids.slice(0);
                values.permissions = permission_list.slice(0);
                values.account_config = [{name: 'if_use_watermark', value: values.if_use_watermark ? true : false}];
                delete values.if_use_watermark;
                const {edit} = this.props;
                let title, content,url,type;
                if (edit) {
                    title = 'Edit Successfully';
                    url =`/sub_accounts/${this.accountId}`;
                    type = 'POST';
                } else {
                    title = 'Create Successfully';
                    content = (
                        <div>
                            <p>Password setting link has been sent to <span style={{color: '#4498f5'}}>{values['email']}</span></p>
                            <p>Please confirm the email address is correct, otherwise you may not receive the email</p>
                        </div>
                    );
                    url = '/sub_accounts';
                    type = 'PUT';
                }
                this.props.abortableAjax(type, url, values).then(
                    () => {
                        Modal.success({
                            title,
                            content,
                            onOk: () => {
                                this.setState({
                                    role_ids: values.roles,
                                    permission_list: values.permissions,
                                    loading: false
                                });
                                toUrl('/pages/sub-account-management');
                            }
                        });
                    }
                ).catch((err) => {
                    this.setState({
                        loading: false
                    });
                });
            }
        });
    }

    getAllParentPermission(permissions) {
        if (permissions) {
            return permissions.filter((item) => {
                return item.is_leaf === 0;
            }).map((item) => {
                return item.id.toString();
            });
        }
    }

    formatPermsByRoleId(userRole) {
        const perm_by_rid = {};
        userRole.map((item) => {
            perm_by_rid[item.id] = [...item.permission_id_list];
        });
        return perm_by_rid;
    }


    setArrayNumToString(arr) {
        if (arr.length > 0) {
            arr = arr.toString().split(',');
        }
        return arr;
    }

    roleSelecte(role_ids, roles_permission_list) {
        const {permission_list, perms_by_role_id} = this.state;
        let rolesPermissionList = [];
        role_ids.map((item)=>{
            rolesPermissionList = _.union(rolesPermissionList,perms_by_role_id[item]);
        });
        this.setState({
            role_ids: [...role_ids],
            permission_list: _.difference(permission_list, this.setArrayNumToString(roles_permission_list)),
            roles_permission_list: [...rolesPermissionList]
        });
    }

    radioChange(e) {
        this.setState({
            radioSelect: e.target.value
        });
    }

    setPermissionTree(permission_list) {
        this.setState({
            permission_list: [...permission_list]
        });
    }

    delSubAccount() {
        Modal.confirm({
            title: 'Confirm Deletion',
            content: 'The deleted sub-account cannot be recovered, are you sure you want to delete it?',
            okType: 'danger',
            onOk: () => {
                this.setState({
                    loading: false
                });
                this.props.abortableAjax('DELETE', `/sub_accounts/${this.accountId}`).then(()=>{
                    Modal.success({
                        title: 'Delete Successfully',
                        onOk: () => {
                            toUrl('/pages/sub-account-management');
                        }
                    });
                });
            }
        });
    }

    resetPassword() {
        this.setState({
            loading: true
        });
        this.props.abortableAjax('POST', `/auth/send-subaccount-mail/${this.accountId}`).then(
            () => {
                Modal.success({
                    title: 'Email Sent Successfully',
                    onOk: () => {
                        this.setState({
                            loading: false
                        });
                    }
                });
            }
        );
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {edit, account_info} = this.props;
        const me = account_info.name;
        const {userRole, permissions} = this.state;
        let {permission_list, roles_permission_list} = this.state;
        const {radioSelect, role_ids,loading} = this.state;
        roles_permission_list = roles_permission_list.map(item => item.toString());
        permission_list = permission_list.map(item=> item.toString());
        const roleTable = <UserRoleTable ref="userRoleTable"
            show={radioSelect === 'role'}
            roleSelecte={this.roleSelecte.bind(this)}
            selectedRole={role_ids}
            dataSource={userRole}/>;
        const permissionTree = <UserPermissionTree ref="userPermissionTree"
            show={radioSelect === 'permission'}
            setPermissionTree={this.setPermissionTree.bind(this)}
            rolesPermissionList={roles_permission_list}
            selectedPermission={permission_list}
            permissions={permissions}/>;
        const allSelectPermissions = permission_list.concat(roles_permission_list);
        let operation;
        const options = {};
        Object.keys(OPTIONS).forEach(key=>{
            const newObj = {...OPTIONS[key]};
            options[key] = newObj;
        });

        if (edit) {
            //编辑状态下不校验name
            options['name'].rules = [];
            operation = ([
                <Button type="primary"
                    key="btn_1"
                    onClick={this.resetPassword.bind(this)}
                    style={{marginTop: '20px', marginRight: '15px'}}>
                    Reset Password
                </Button>,
                <Button type="danger"
                    key="btn_2"
                    onClick={this.delSubAccount.bind(this)}
                    style={{marginTop: '20px'}}>
                    Delete
                </Button>
            ]);
        }

        return (
            <Spin spinning={loading}>
                <Form layout="vertical"
                    autoComplete="off"
                    onSubmit={this.handleSubmit.bind(this)}>
                    <FormItem label={SubAccountForm.getLabel('Sub-account Name', 'Allowed characters: numbers, letters, -. Must start with a letter, length between 6-20 characters')}>
                        {getFieldDecorator('name', options.name)(
                            <Input addonBefore={me && me.includes(':') ? me.split(':')[0] : me} disabled={edit}/>
                        )}
                    </FormItem>
                    {/* <FormItem label={SubAccountForm.getLabel('ID Card')}>
                        {getFieldDecorator('id_card', options.id_card)(
                            <Input />
                        )}
                    </FormItem> */}
                    <FormItem label={SubAccountForm.getLabel('Real Name')}>
                        {getFieldDecorator('real_name', options.real_name)(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label={SubAccountForm.getLabel('Username')}>
                        {getFieldDecorator('display_name', options.display_name)(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label={SubAccountForm.getLabel('Phone')}>
                        {getFieldDecorator('phone', options.phone)(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label={SubAccountForm.getLabel('Email', 'The link to set the initial login password for this sub-account will be sent to this email, please confirm the email address is correct.')}>
                        {getFieldDecorator('email', options.email)(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label={SubAccountForm.getLabel('Description')}>
                        {getFieldDecorator('description', options.description)(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem label={SubAccountForm.getLabel('Permissions')}>
                        <RadioGroup defaultValue="role" onChange={this.radioChange.bind(this)}>
                            <RadioButton value="role">Roles({role_ids.length})</RadioButton>
                            <RadioButton value="permission">Permissions({allSelectPermissions.length})</RadioButton>
                        </RadioGroup>
                    </FormItem>

                    {roleTable}
                    {permissionTree}
                    <FormItem>
                        <Button type="primary"
                            style={{marginTop: '30px'}}
                            htmlType="submit">
                            Confirm
                        </Button>
                    </FormItem>
                </Form>
                {operation}
            </Spin>
        );
    }
}

SubAccountForm.defaultProps = {};

const WrappedSubAccountForm = Form.create()(SubAccountForm);
// export default WrappedSubAccountForm;

function select(state) {
    return {
        account_info: state.account.info,
    };
}


export default connect(select)(abortAjaxHoc(WrappedSubAccountForm));



// WEBPACK FOOTER //
// ./src/pages/SubAccountManagement/SubAccountForm/index.js